<div class="home-card app-widget-project" *ngIf="projects">
    <div class="title carousel-control">
        <h3>{{ 'home.widgetProject.title' | translate }}</h3>

        <div class="carousel-control-btn d-none d-md-flex">
            <button
                type="button"
                data-target="#carouselProjects"
                data-slide="prev"
                [disabled]="projects.length <= 1"
                [appTrack]="'homepage_project_carousel_browsed'"
                [appTrackParams]="{
                    direction: 'previous'
                }"
            >
                <i class="pi pi-angle-left"></i>
                <span class="sr-only">Previous</span>
            </button>
            <button
                type="button"
                data-target="#carouselProjects"
                data-slide="next"
                [disabled]="projects.length <= 1"
                [appTrack]="'homepage_project_carousel_browsed'"
                [appTrackParams]="{
                    direction: 'next'
                }"
            >
                <i class="pi pi-angle-right"></i>
                <span class="sr-only">Next</span>
            </button>
        </div>
    </div>

    <div id="carouselProjects" class="carousel slide" data-ride="carousel" data-interval="false">
        <div class="carousel-inner">
            <ng-container *ngIf="projects.length > 0 && !isLoading">
                <div id="{{ project.id }}" class="carousel-item" *ngFor="let project of projects; let isFirst = first" [class.active]="isFirst">
                    <div class="d-flex flex-md-row flex-column">
                        <div class="carousel-left-items d-none d-md-flex">
                            <div class="d-flex flex-column align-items-center w-fit">
                                <i class="pi pi-users"></i>
                                <p class="bold-info">{{ project.attendeesCount }}</p>
                            </div>

                            <button
                                (click)="openJoinProjectDialog()"
                                class="btn btn-secondary"
                                type="button"
                                [appTrack]="'homepage_project_join_clicked'"
                                [appTrackParams]="{
                                    project_id: project.id
                                }"
                            >
                                {{ 'home.widgetProject.join' | translate }}
                            </button>
                        </div>

                        <a tabindex="0" (click)="goToProjectPage(project.id)" class="carousel-main">
                            <h4>{{ project.name }}</h4>
                            <p class="font-detail">{{ project.typeLabel }}</p>

                            <div class="carousel-dates">
                                <p>
                                    <span class="font-detail">{{ 'home.widgetProject.startDate' | translate }}</span
                                    ><br />{{ project.startDate | dateFormatted }}
                                </p>

                                <i class="pi pi-caret-right"></i>

                                <p>
                                    <span class="font-detail">{{ 'home.widgetProject.endDate' | translate }}</span
                                    ><br />{{ project.endDate | dateFormatted }}
                                </p>
                            </div>

                            <div class="widget-pill-container">
                                <span *ngFor="let tagName of project.tags" [ngClass]="{ fav: userTags.includes(tagName) }"> {{ tagName }}</span>
                            </div>
                        </a>
                    </div>

                    <dialog-join-project
                        class="position-absolute"
                        [visible]="joinProjectDialog"
                        [project]="project"
                        [displaySeeMoreButton]="true"
                        (acted)="userJoinedProject()"
                        (visibleChange)="closeJoinProjectDialog()"
                    >
                    </dialog-join-project>
                </div>
            </ng-container>

            <!-- SKELETON START -->
            <div class="carousel-item active" *ngIf="isLoading">
                <div class="d-flex flex-md-row flex-column">
                    <div class="carousel-left-items d-none d-md-flex">
                        <div class="d-flex flex-column align-items-center w-fit">
                            <i class="pi pi-users"></i>
                            <p class="bold-info"><p-skeleton height="2rem" width="4rem"></p-skeleton></p>
                        </div>

                        <button class="btn btn-secondary" type="button" disabled>{{ 'home.widgetProject.join' | translate }}</button>
                    </div>

                    <a class="carousel-main w-0 w-md-100" style="pointer-events: none; cursor: default">
                        <h4><p-skeleton width="100%" height="3rem"></p-skeleton></h4>
                        <p><p-skeleton width="10rem"></p-skeleton></p>

                        <div class="carousel-dates">
                            <p>
                                <span>{{ 'home.widgetProject.startDate' | translate }}</span
                                ><br /><p-skeleton width="10rem"></p-skeleton>
                            </p>

                            <i class="pi pi-caret-right"></i>

                            <p>
                                <span>{{ 'home.widgetProject.endDate' | translate }}</span
                                ><br /><p-skeleton width="10rem"></p-skeleton>
                            </p>
                        </div>

                        <div class="widget-pill-container" style="overflow: visible">
                            <p-skeleton height="2rem" borderRadius="50px" width="12rem"></p-skeleton>
                            <p-skeleton height="2rem" borderRadius="50px" width="6rem"></p-skeleton>
                            <p-skeleton height="2rem" borderRadius="50px" width="9rem"></p-skeleton>
                            <p-skeleton height="2rem" borderRadius="50px" width="8rem"></p-skeleton>
                        </div>
                    </a>
                </div>
            </div>
            <!-- SKELETON END -->
            <p class="empty-state" *ngIf="projects.length <= 0 && !isLoading">{{ 'home.widgetProject.emptyState' | translate }}</p>
        </div>
    </div>

    <div class="mobile-bottom-actions d-md-none">
        <div class="mobile-controler">
            <button
                class="btn btn-secondary"
                type="button"
                data-target="#carouselProjects"
                [disabled]="projects.length <= 1"
                data-slide="prev"
                [appTrack]="'homepage_project_carousel_browsed'"
                [appTrackParams]="{
                    direction: 'previous'
                }"
            >
                <i class="pi pi-angle-left"></i>
                <span class="sr-only">Previous</span>
            </button>
            <button
                class="btn btn-secondary"
                type="button"
                data-target="#carouselProjects"
                [disabled]="projects.length <= 1"
                data-slide="next"
                [appTrack]="'homepage_project_carousel_browsed'"
                [appTrackParams]="{
                    direction: 'next'
                }"
            >
                <i class="pi pi-angle-right"></i>
                <span class="sr-only">Next</span>
            </button>
        </div>

        <button
            (click)="openJoinProjectDialog()"
            class="btn btn-secondary"
            type="button"
            [appTrack]="'homepage_project_join_clicked'"
            [appTrackParams]="{
                project_id: currentProject?.id
            }"
        >
            {{ 'home.widgetProject.join' | translate }}
        </button>
    </div>
</div>
